const MUSIC_PAUSED_KEY = 'fgv_music_paused';
export const MUSIC_PREFERENCE_EVENT = 'fgv-music-preference-change';

export const isMusicPausedByUser = () => {
    try {
        return window.localStorage.getItem(MUSIC_PAUSED_KEY) === 'true';
    } catch {
        return false;
    }
};

export const saveMusicPausedPreference = (paused: boolean) => {
    try {
        window.localStorage.setItem(MUSIC_PAUSED_KEY, String(paused));
    } catch {
        // La preferencia sigue funcionando durante la sesion si el navegador
        // bloquea el almacenamiento local.
    }

    window.dispatchEvent(new CustomEvent(MUSIC_PREFERENCE_EVENT, {
        detail: { paused }
    }));
};
